<template>
  <div @click="toggle" class="ml-steps__item">
    <step :completed="completed" :show="show" @close="toggle">
      <div class="ml-steps-card__title">{{$t("mylist.enablePiggybank")}}</div>
      <template v-slot:icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M15.4812 6.98196C15.3492 6.60422 15.043 6.47374 14.9422 6.43106C14.644 6.3042 14.3446 6.16205 14.0896 6.03963C14.0893 6.03963 14.0885 6.03882 14.0881 6.03842C13.7594 5.43839 13.3326 4.90923 12.8188 4.46464C12.8229 3.90206 12.8218 3.33223 12.8207 2.78093V2.74871C12.8196 2.25056 12.5183 1.9288 12.0527 1.9288C12.0425 1.9288 12.032 1.9288 12.0215 1.9292C11.7044 1.93887 11.3953 2.01619 11.1008 2.15915C10.642 1.16165 9.66673 0.5 8.6381 0.5C8.50083 0.5 8.36318 0.511678 8.22891 0.535438C6.95244 0.757732 5.99903 1.84061 5.88545 3.18484C5.25022 3.39143 4.65975 3.69024 4.12945 4.07281C3.06961 4.83755 2.37308 5.76538 2.00149 6.90826C1.98005 6.86598 1.96162 6.82047 1.9462 6.77134C1.87625 6.54945 1.89506 6.32957 2.00337 6.09923C2.10191 5.88982 2.11658 5.66068 2.04474 5.45329C1.97554 5.25354 1.83338 5.09729 1.64457 5.01313C1.55394 4.97286 1.45878 4.95232 1.36137 4.95232C1.08005 4.95232 0.833709 5.12307 0.718623 5.39852C0.629488 5.61155 0.519292 6.02271 0.501991 6.48099C0.477921 7.11002 0.672739 7.69475 1.05072 8.12766C1.24854 8.35398 1.49188 8.53721 1.77508 8.67212C1.86835 10.2459 2.55962 11.5265 3.88611 12.5852C3.97939 12.6597 4.01361 12.7121 4.03317 12.8091C4.13509 13.3157 4.24754 13.8264 4.35624 14.3201L4.36188 14.3462C4.39723 14.5061 4.43221 14.6664 4.46719 14.8263C4.56459 15.2729 4.81771 15.4919 5.24119 15.496C5.45482 15.498 5.67032 15.4992 5.88131 15.4992C6.0923 15.4992 6.30705 15.498 6.51541 15.496C6.93664 15.4919 7.189 15.2717 7.28716 14.8235L7.46506 14.0112H9.00931L9.12327 14.5287C9.13117 14.5641 9.13869 14.5995 9.14583 14.6346L9.25603 14.608L9.14696 14.639C9.16539 14.726 9.1842 14.8158 9.20789 14.9068C9.29966 15.2628 9.54751 15.4795 9.87057 15.4867C10.1211 15.4923 10.3715 15.4952 10.6156 15.4952C10.8597 15.4952 11.0884 15.4928 11.3204 15.4875C11.6608 15.4799 11.9139 15.2499 11.9974 14.8718C12.0583 14.5955 12.1185 14.3189 12.1783 14.0426L12.1855 14.0092C12.2791 13.5771 12.3761 13.1301 12.475 12.6919C12.4788 12.6823 12.4901 12.6641 12.4969 12.6561C13.1799 12.1233 13.7004 11.5205 14.0859 10.8149C14.0885 10.8117 14.093 10.8077 14.096 10.8048C14.3514 10.6824 14.6474 10.5423 14.9426 10.4166C15.2164 10.3003 15.3928 10.1194 15.4812 9.86332L15.5 9.80896V7.03471L15.4808 6.97994L15.4812 6.98196ZM13.3307 9.47431C13.2449 9.51981 13.0332 9.64948 12.9226 9.87057C12.6003 10.5149 12.1298 11.0577 11.5239 11.483C11.2945 11.6441 11.1591 11.8567 11.0985 12.1519C11.0357 12.4567 10.9673 12.7741 10.9067 13.0548C10.8439 13.3467 10.7789 13.648 10.7172 13.9472C10.6732 13.9456 10.6258 13.9447 10.5735 13.9447C10.5438 13.9447 10.5141 13.9447 10.4836 13.9456L10.4573 13.8239C10.3979 13.5477 10.3366 13.2622 10.273 12.9831C10.1869 12.6041 9.9142 12.3686 9.5618 12.3686C9.51328 12.3686 9.46364 12.373 9.41362 12.3818C9.40233 12.3839 9.35683 12.3923 9.35683 12.3927C8.98675 12.4596 8.60839 12.4934 8.23305 12.4934C7.8577 12.4934 7.45979 12.4584 7.07128 12.3891C7.01562 12.379 6.96109 12.3742 6.90918 12.3742C6.54888 12.3742 6.28073 12.6166 6.19197 13.0226L6.14683 13.2279C6.09493 13.4627 6.0419 13.7043 5.99264 13.9464C5.95427 13.9452 5.91554 13.9447 5.87717 13.9447C5.83881 13.9447 5.79895 13.9452 5.75983 13.9464C5.71169 13.718 5.66167 13.4889 5.61315 13.2666C5.53643 12.9146 5.4567 12.5502 5.38524 12.191C5.32318 11.8793 5.1735 11.6493 4.91399 11.4673C4.28816 11.0275 3.84587 10.5165 3.56267 9.9052C3.00229 8.69628 3.10759 7.51997 3.87521 6.40891C4.40287 5.64538 5.14717 5.09367 6.14909 4.72479L6.24086 4.91608C6.12276 5.11662 6.09531 5.3369 6.16188 5.55718C6.24989 5.84874 6.462 6.04365 6.74333 6.09158C6.81666 6.10406 6.88662 6.10567 6.94529 6.10607C7.58917 6.10607 8.23267 6.10648 8.87655 6.10648C9.35645 6.10648 9.83635 6.10648 10.3163 6.10607C10.912 6.10567 11.0707 5.68081 11.1109 5.49799C11.1647 5.25515 11.0959 5.0679 11.0135 4.92574C11.1722 4.62613 11.2824 4.30356 11.3415 3.96569C11.3475 3.93226 11.3588 3.89803 11.375 3.86421C11.3757 4.15577 11.3757 4.45296 11.3712 4.74493C11.3659 5.06749 11.4874 5.32925 11.7319 5.52215C12.2328 5.91761 12.6323 6.40488 12.9181 6.96947C13.0328 7.1966 13.2457 7.32869 13.3318 7.375C13.5443 7.48937 13.7628 7.58561 13.9749 7.67864C13.9749 7.67864 14.0313 7.70361 14.055 7.71408C14.0535 7.93476 14.0535 8.15705 14.0532 8.37492C14.0532 8.61211 14.0532 8.8783 14.0505 9.13724C13.9719 9.17429 13.8911 9.21053 13.8102 9.24718C13.6534 9.31765 13.4913 9.39054 13.3318 9.47511L13.3307 9.47431ZM8.80998 2.07055C9.36472 2.13982 9.82883 2.63072 9.91345 3.238C9.98641 3.76192 9.83146 4.18959 9.43881 4.54518C9.4328 4.5476 9.42189 4.55082 9.41512 4.55122C9.31207 4.55445 9.19811 4.55606 9.0567 4.55606C8.98449 4.55606 8.91228 4.55606 8.84007 4.55525C8.76673 4.55525 8.69377 4.55445 8.62043 4.55445C8.54709 4.55445 8.47601 4.55445 8.40417 4.55525H8.39514C8.32707 4.55565 8.259 4.55606 8.19092 4.55606C8.0529 4.55606 7.94157 4.55445 7.8404 4.55122C7.83175 4.55122 7.81784 4.54599 7.81144 4.54277C7.35486 4.15617 7.19539 3.48647 7.42331 2.91221C7.63242 2.38628 8.0984 2.05968 8.63998 2.05968C8.69602 2.05968 8.75319 2.06331 8.8096 2.07015L8.80998 2.07055Z"
            fill="#424142"
          />
          <path
            d="M11.5398 6.63965H11.5323C11.1377 6.63965 10.8132 6.98195 10.8086 7.40318C10.8041 7.82924 11.1249 8.1796 11.5247 8.18443H11.5323C11.9264 8.18443 12.251 7.84213 12.2559 7.4209C12.2581 7.21512 12.1844 7.02021 12.0486 6.87201C11.9132 6.72422 11.7327 6.64166 11.5398 6.63965Z"
            fill="black"
          />
        </svg>
      </template>
      <template v-slot:modal>
        <div class="card-wizard">
          <div class="card-wizard__title">
            <h3 class="header-3">{{$t("mylist.enablePiggybank")}}</h3>
            <div class="card-wizard__subtitle" v-if="!stripeAccountActive">
              {{ $t("mylist.widgetPiggybankSubtitle") }}
            </div>
            <div class="card-wizard__subtitle" v-else>
              {{ $t("mylist.widgetPiggybankAlreadyEnabled") }}
              <router-link to="/contributions" class="link">{{ $t("generic.here") }}</router-link>.
            </div>
          </div>
          <form
            class="card-wizard__container card-wizard__container--block"
            v-show="!stripeAccountActive"
          >
            <div class="card-wizard__actions">
              <bbButtonVue
                :label="buttonText"
                :loading="loading"
                @click="action"
              ></bbButtonVue>
            </div>

            <div class="card-wizard__aceptance">
              <div class="bb-form-checkbox">
                <input
                  type="checkbox"
                  name="checkbox"
                  id="noHucha"
                  data-name="Checkbox"
                  v-model="noHucha"
                />
                <label class="bb-form-checkbox__label" for="noInvite">
                  {{ $t("mylist.widgetPiggybankNo") }}
                </label>
              </div>
            </div>
          </form>
        </div>
      </template>
    </step>
    <alert v-if="showAlertLocal" :key="key" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import bbButtonVue from "../../../components/buttons/bbButton.vue";
import Step from "./Step";
import OwnerListAlert from "./OwnerListAlert";

export default {
  name: "HuchaStep",
  components: {
    Step,
    bbButtonVue,
    alert: OwnerListAlert,
  },
  data() {
    return {
      show: false,
      loading: false,
      noHucha: false,
      key: "hucha_step",
      stripeAccountActive: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
    }),
    completed() {
      //return this.noHucha || (this.user.stripeAccountId !== null && this.user.stripeAccountId !== "");
      return this.noHucha || this.user.contributionMethods.length > 0;
    },
    buttonText() {
      return this.noHucha ? this.$t("generic.save") : this.$t("mylist.enablePiggybank");
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    async action() {
      if (this.noHucha) {
        await this.refuseContributions();
      } else {
        this.activateHucha();
      }
    },
    async refuseContributions() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("refuseContributions", {});

        if (response && response.status === 200) {
          window.mixpanel.track("Contributions refused");
          this.show = false;
          this.$alert.success(
            this.$t("mylist.widgetPiggybankSuccess"),
            this.key
          );
        }
      } catch (error) {
        console.log(error);
        this.$alert.error(
          this.$t("mylist.widgetPiggybankError"),
          this.key
        );
      } finally {
        this.loading = false;
      }
    },
    async activateHucha() {
      this.loading = true;
      this.$router.push({ name: "hucha-crear" });
    },
  },
  mounted() {
    this.noHucha = this.user.contributionsRefused;
    // this.stripeAccountActive =
    //   this.user.stripeAccountId != null && this.user.stripeAccountId !== "";
    this.stripeAccountActive = this.user.contributionMethods.length > 0;
  },
};
</script>
